// Mock data for districts
import { District } from './types';

export const mockDistricts: District[] = [
  {
    id: 'district-1',
    name: 'Riverside Unified School District',
    address: '3380 14th St, Riverside, CA 92501',
    phone: '(951) 788-7135',
    website: 'www.riversideunified.org',
    logo: '/images/districts/riverside-logo.png',
    totalSchools: 50,
    totalStudents: 42000,
    totalTeachers: 1800,
    lastSynced: '2025-05-23T08:30:00',
    status: 'active',
    createdAt: '2024-01-15T10:00:00',
    updatedAt: '2025-05-23T08:30:00'
  },
  {
    id: 'district-2',
    name: 'Swun Unified School District',
    address: '5678 Education Ave, Springfield, CA 12345',
    phone: '(555) 123-4567',
    website: 'www.swununified.org',
    logo: '/images/districts/swun-logo.png',
    totalSchools: 35,
    totalStudents: 28000,
    totalTeachers: 1200,
    lastSynced: '2025-05-24T10:15:00',
    status: 'active',
    createdAt: '2024-01-20T09:30:00',
    updatedAt: '2025-05-24T10:15:00'
  }
];
